// extracted by mini-css-extract-plugin
export var indeterminate = "_5m-6";
export var md = "_5m-5";
export var semantic = "_5m-7";
export var sm = "_5m-4";
export var text = "_5m-8";
export var toggleControl = "_5m-0";
export var toggleInput = "_5m-1";
export var toggleSwitch = "_5m-2";
export var xs = "_5m-3";